<template>

  <div class="cdr-analysis">


    <template v-if="missing.length > 0">
      <headline>
        Cdr manquants
      </headline>
      <v-data-table
        :headers="[
            {text: 'type', value: 'type'},
            {text: 'startTime', value: 'startTime'},
            {text: 'stopTime', value: 'stopTime'},
            {text: 'startMeter', value: 'startMeter'},
            {text: 'stopMeter', value: 'stopMeter'},
            {text: 'energy', value: 'energy'},
            {text: 'transactionId', value: 'transactionId'},
            {text: 'evse-id', value: 'evseId'},
        ]"
        :items="missing"
      >
        <template #item="{item}">
          <tr :class="{missing: item.type === 'missing'}">
            <td class="text-start">{{ item.type }}</td>
            <td class="text-start">{{ item.startTime }}</td>
            <td class="text-start">{{ item.stopTime }}</td>
            <td class="text-start">{{ item.startMeter }}</td>
            <td class="text-start">{{ item.stopMeter }}</td>
            <td class="text-start">{{ item.energy }}</td>
            <td class="text-start">{{ item.transactionId }}</td>
            <td class="text-start">{{ item.evseId }}</td>
          </tr>
        </template>

      </v-data-table>
      <hr>
    </template>


    <template v-if="duplicated.length > 0">
      <headline>
        Cdr en double
      </headline>
      <v-data-table
        :headers="[
            {text: 'type', value: 'type'},
            {text: 'startTime', value: 'startTime'},
            {text: 'stopTime', value: 'stopTime'},
            {text: 'startMeter', value: 'startMeter'},
            {text: 'stopMeter', value: 'stopMeter'},
            {text: 'energy', value: 'energy'},
            {text: 'transactionId', value: 'transactionId'},
            {text: 'evse-id', value: 'evseId'},
        ]"
        :items="duplicated"
      >
        <template #item="{item}">
          <tr :class="{duplicated: item.type === 'duplicated'}">
            <td class="text-start">{{ item.type }}</td>
            <td class="text-start">{{ item.startTime }}</td>
            <td class="text-start">{{ item.stopTime }}</td>
            <td class="text-start">{{ item.startMeter }}</td>
            <td class="text-start">{{ item.stopMeter }}</td>
            <td class="text-start">{{ item.energy }}</td>
            <td class="text-start">{{ item.transactionId }}</td>
            <td class="text-start">{{ item.evseId }}</td>
          </tr>
        </template>
      </v-data-table>
      <hr>
    </template>


    <template v-if="sessionAuthorizations.length > 0">
      <headline>
        Autorisations
      </headline>
      <v-data-table
          :headers="[
          {text: 'createdAt', value: 'createdAt'},
          {text: 'transactionId', value: 'transactionId'},
          {text: 'sessionId', value: 'sessionId'},
          {text: 'status', value: 'status'},
          {text: 'evse-id', value: 'evse.evseId'},
          {text: 'tokenUid', value: 'token.uid'},
          {text: 'evcoId', value: 'token.evcoId'},
      ]"
          :items="sessionAuthorizations"
      ></v-data-table>
    </template>


    <template v-if="sessions.length > 0">
      <headline>
        Sessions
      </headline>
      <v-data-table
          :headers="[
          {text: 'createdAt', value: 'createdAt'},
          {text: 'transactionId', value: 'transactionId'},
          {text: 'cdrId', value: 'cdrId'},
          {text: 'startTime', value: 'startTime'},
          {text: 'stopTime', value: 'stopTime'},
          {text: 'energy', value: 'energy'},
          {text: 'startMeter', value: 'startMeter'},
          {text: 'stopMeter', value: 'stopMeter'},
          {text: 'evse-id', value: 'evse.evseId'},
          {text: 'tokenUid', value: 'token.uid'},
          {text: 'evcoId', value: 'token.evcoId'},
      ]"
          :items="sessions"
      ></v-data-table>
    </template>


    <template v-if="chargingPointMessages.length > 0">
      <headline>
        Logs des bornes
      </headline>
      <v-data-table
          :headers="[
            {text: 'date', value: 'date'},
            {text: 'action', value: 'action'},
            {text: 'transactionId', value: 'transactionId'},
            {text: 'meterValue', value: 'meterValue'},
            {text: 'tokenUid', value: 'tokenUid'},
        ]"
          :items="chargingPointMessages"
      ></v-data-table>
    </template>

  </div>
</template>

<script>
import ChargingPointRepository from "@repository/ChargingPointRepository";

export default {
  components: {},


  data() {
    return {
      month: null,
      missing: [],
      duplicated: [],
      chargingPointMessages: [],
      sessions: [],
      sessionAuthorizations: [],
    }
  },

  mounted() {
    this.loadData()
  },



  watch: {

  },

  computed:  {
    chargingPoint() {
      return this.$parent.chargingPoint
    },

  },

  methods: {
    loadData() {
      this.showLoading(true)
      ChargingPointRepository.chargingPointMeterDiscontinuities(this.chargingPoint.id, this.month).then(result => {
        this.missing = result.missing.map(d => ({...d, createdAt: this.formatDate(d.createdAt), startTime: this.formatDate(d.startTime), stopTime: this.formatDate(d.stopTime)}))
        this.duplicated = result.duplicated.map(d => ({...d, createdAt: this.formatDate(d.createdAt), startTime: this.formatDate(d.startTime), stopTime: this.formatDate(d.stopTime)}))
        this.sessions = result.sessions.map(d => ({...d, createdAt: this.formatDate(d.createdAt), startTime: this.formatDate(d.startTime), stopTime: this.formatDate(d.stopTime)}))
        this.sessionAuthorizations = result.sessionAuthorizations.map(d => ({...d, createdAt: this.formatDate(d.createdAt)}))
        this.chargingPointMessages = result.chargingPointMessages.map(d => ({...d, date: this.formatDate(d.date)}))
        this.showLoading(false)
      }).catch(err => {
        this.notifyError(err)
        this.showLoading(false)
      })
    }
  }
}
</script>

<style lang="scss">
.cdr-analysis {
  tr {
    &.missing {
      td {
        background-color: #ffeeee;
        color: red;
      }
    }
    &.duplicated {
      td {
        background-color: #ffeeee;
        color: red;
      }
    }
  }
}

</style>
